// Kids Cloud Rocking Chair: Explore section (sections/wc-cloud-anatomy.liquid)
if (!customElements.get('wc-cloud-explore')) {
  customElements.define(
    'wc-cloud-explore',
    class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.wc-cloud-explore__stage');
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.shots = [...this.querySelectorAll('.wc-cloud-explore__shot')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.index = 0;
        this.delay = 4800;
        if (!this.tabs.length) return;

        const pick = (index, focus = false) => {
          this.stop();
          this.select(index, focus);
        };

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => pick(index));
          tab.addEventListener('keydown', (event) => {
            const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
            if (event.key === 'Home') pick(0, true);
            else if (event.key === 'End') pick(this.tabs.length - 1, true);
            else if (keys[event.key]) pick((index + keys[event.key] + this.tabs.length) % this.tabs.length, true);
            else return;
            event.preventDefault();
          });
        });

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduce && this.tabs.length > 1) {
          this.observer = new IntersectionObserver(
            ([entry]) => (entry.isIntersecting ? this.play() : this.pause()),
            { threshold: 0.45 }
          );
          this.observer.observe(this);
          this.addEventListener('pointerenter', () => this.pause());
          this.addEventListener('pointerleave', () => !this.stopped && this.play());
          this.addEventListener('focusin', () => this.stop());
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        clearInterval(this.timer);
      }

      select(index, focus = false) {
        this.index = index;
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          if (on && focus) tab.focus();
        });
        this.panels.forEach((panel, i) => {
          const on = i === index;
          panel.classList.toggle('is-active', on);
          if (on) panel.removeAttribute('aria-hidden');
          else panel.setAttribute('aria-hidden', 'true');
        });
        this.shots.forEach((shot, i) => {
          const on = i === index;
          if (on) shot.querySelector('img')?.setAttribute('loading', 'eager');
          shot.classList.toggle('is-active', on);
        });
      }

      play() {
        if (this.stopped || this.timer) return;
        this.stage.classList.add('is-cycling');
        this.timer = setInterval(() => this.select((this.index + 1) % this.tabs.length), this.delay);
      }

      pause() {
        clearInterval(this.timer);
        this.timer = null;
        this.stage.classList.remove('is-cycling');
      }

      stop() {
        this.stopped = true;
        this.pause();
      }
    }
  );
}